// ============================================
// PIPELINE TYPES
// ============================================
// ============================================
// PIPELINE CONSTANTS
// ============================================
/** Supported placeholders in email templates */
export const EMAIL_PLACEHOLDERS = [
    '{candidateName}',
    '{jobTitle}',
    '{stageName}',
    '{orgName}',
];
/** Pipeline limits */
export const PIPELINE_LIMITS = {
    MAX_CUSTOM_STAGES: 15,
    MIN_CUSTOM_STAGES: 1,
    MAX_STAGE_NAME_LENGTH: 60,
    MIN_STAGE_NAME_LENGTH: 1,
    MAX_TEMPLATES_PER_ORG: 20,
    MAX_TEMPLATE_NAME_LENGTH: 80,
    MIN_TEMPLATE_NAME_LENGTH: 3,
    MAX_EMAILS_PER_JOB_PER_DAY: 50,
};
